<!-- Header -->
<h3 mat-dialog-title translate>
    {{information && information.ProfileContentId != -1 ? 'Edit' : 'Add'}} Content
</h3>

<!-- Body -->
<mat-dialog-content style="height: 100vh;">
    <form style="flex-grow: 1; display: flex; flex-direction: column;">

        <!-- Check for null info -->
        <ng-container *ngIf="information">

            <!-- Title Field -->
            <tyl-form-field label="Title"
                style="width: 100%">
                <input matInput
                    [(ngModel)]="information.Title"
                    id="titleField"
                    #titleField
                    name="title"
                    maxlength="100"
                    [required]="true" />
            </tyl-form-field>
            <br />

            <!-- Inline Fields  -->
            <div style="width: 50vw; display: flex; align-items: baseline; min-width: 730px;">

                <!-- Date Fields -->
                <div style="flex: 1 0 250px">
                    <tyl-datepicker [value]="information.DateFromView && information.DateFromView.toString() != junkDate.toString() ?
                        information.DateFromView :
                        null"
                        (valueChange)="information.DateFromView = $event"
                        label="Start Date"
                        id="startPicker" [showTodayButton]="true"></tyl-datepicker>
                    <br />
                    <tyl-datepicker [value]="information.DateToView && information.DateToView.toString() != junkDate.toString() ?
                        information.DateToView :
                        null"
                        (valueChange)="information.DateToView = $event"
                        label="End Date"
                        id="endPicker" [showTodayButton]="true"></tyl-datepicker>
                </div>

                <!-- Active Checkbox -->
                <div *ngIf="V10" style="flex: 1 0 80px;">
                    <tyl-checkbox [checked]="information.Status == 'A'"
                        (change)="setStatus()"
                        name="active"
                        id="activeCheckbox">
                        Active
                    </tyl-checkbox>
                </div>

                <div *ngIf="!V10" style="flex: 1 0 80px;">
                    <tyl-form-field label="Status">
                        <mat-select id="contentStatus" name="ContentStatus"
                                    [(ngModel)]="information.Status">
                            <mat-option id="contentStatusActive" value="A">Active</mat-option>
                            <mat-option id="contentStatusInactive" value="I">Inactive</mat-option>
                        </mat-select>
                    </tyl-form-field>
                </div>

                <!-- Picture (???) -->
                <div *ngIf="V10" style="flex: 1 0 250px; display: flex; position: relative; align-items: baseline;">
                    <label style="padding-right: 16px; padding-top: 6px;" translate>Picture</label>
                    <img style="max-height: 64px; max-width: 64px; padding-right: 10px;"
                        [src]="resourceSrc()" />
                    <add-file style="display: flex;"
                        [(fileString)]="information.Image"
                        [(fileName)]="pictureName"
                        [showFileName]="false"
                        width="unset"
                        buttonLabel="Browse"></add-file>
                </div>
            </div>

            <!-- Content -->
            <div style="flex-grow: 1; flex-shrink: 1; overflow: hidden; width: 100%;"
                #quillContainer>
                <quill-editor name="content" id="contentField" [(ngModel)]="information.Content"
                    [ngStyle]="{'height': 'calc(' + quillHeight + ' - 66px)'}"></quill-editor>
                <!-- NOTE: we subtract 66px to account for the toolbar -->
            </div>
        </ng-container>
    </form>
    <div *ngIf="!V10" style="max-height: 180px; overflow: auto;" [ngStyle]="information && information.ProfileAttachments && information.ProfileAttachments.length > 0 &&   {'min-height':'180px'}">
        <attachment-table [userCanEdit]="userCanEdit"
                          [profile]="information"
                          [attachmentChanged]="attachmentChanged">
        </attachment-table>
    </div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

	<!-- Left -->
	<div class="flex-footer-left">
		<tyl-button *ngIf="V10" image="Paperclip.png"
			label="Attachments"
			(clickEvent)="attachments()"></tyl-button>
        <tyl-button *ngIf="!V10 && userCanEdit"
            image="add.png"
            label="Add Attachment"
            (clickEvent)="addAttachment()"></tyl-button>
	</div>

	<!-- Right -->
    <div class="flex-footer-right">
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="save.png" label="Save" (clickEvent)="save()"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancel()"></tyl-button>
    </div>
</mat-dialog-actions>
